import { SerializedData, Store } from "bernie-core";
import { Logger } from "bernie-logger";

import { HotwireApiConfig } from "components/utility/hotwire/HotwireApiUtil";

export interface HotwireConfig {
  emailValidationService: HotwireApiConfig;
  emailSubscriptionService: HotwireApiConfig;
}

export class HotwireConfigStore extends Store {
  public config: HotwireConfig;
  public logger: Logger;

  public constructor(serverConfig: SerializedData, logger: Logger) {
    super(serverConfig, logger);

    // On server, get required config and pass it to the client via hydration
    this.config = serverConfig?.app?.hotwire;

    // Expose logger so it can be used from outside
    this.logger = logger;
  }

  public hydrate(data: SerializedData): void {
    // On client, get config from hydrated data
    this.config = data.config;
  }

  public toJSON(ignoreAdditionalKeys?: string[] | string): SerializedData {
    return { config: this.config };
  }
}
